export default __webpack_public_path__ + "static/media/012-tooth.c97272ba.svg";